<template>
  <div class="home-box">

  <div :class="isMobile ? 'main-m' : 'main'">
    <div class="overview">
      <div class="overview-title">产品导览</div>
      <div class="overview-subtitle">Product Guide</div>
      <div class="overview-content" ref="overviewRef">
        <div class="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in productlist" :key="i" :data-id="i">
              <div class="swipperItem overview-content-one">
                <div class="imgbox">
                  <img :src="item.url" />
                </div>
                
                <div class="content">
                  <div class="word">{{item.name}}</div>
                  <div class="btn">查看详情</div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev projectlist_prev"></div>
          <div class="swiper-button-next projectlist_next" ></div>
        </div>
      </div>
    </div>

    <!-- 解决方案 -->
    <div class="word">
      <div class="word-title" ref="wordRef" :class="{titleMove: isTitleMove}">
        <div class="word-big">解决方案</div>
        <div class="word-small">Solution</div>
      </div>
    </div>
    <div class="cards-container">
      <!-- 卡片 -->
      <div class="card" v-for="(item,index) in solutionlist" :class="{ 'active': index==2 }" @click="seePlanDetail(item)">
        <img class="card-big-pic" :src="item.bg" v-show="!isMobile" />
        <div class="card-icon">
          <img :src="item.icon" class="card-icon-img" />
          <div class="card-icon-text">{{ item.text }}</div>
        </div>
        <div class="card-content"></div>
      </div>
      <div class="card" @click="seePlanDetail()" v-if="isMobile">
        <div class="card-icon">
          <i class="el-icon-more card-icon-img"></i>
          <div class="card-icon-text">了解更多</div>
        </div>
        <div class="card-content"></div>
      </div>
    </div>

      <!-- 应用领域 -->
      <div class="word">
        <div class="word-title" :class="{titleMove: isTitleMove}">
          <div class="word-big">应用领域</div>
          <div class="word-small">Application Areas</div>
        </div>
      </div>
      <div class="place-box">
        <el-row :gutter="20">
          <el-col :span="isMobile?24:6" v-for="(item, index) in placelist" :key="index">
            <div  class="place-one" @click="jumpToPlace(index)">
              <div class="leftbox">
                <img :src="item.url" class="place-one-img" />
                <div class="place-one-text">
                  {{ item.text }}
                </div>
              </div>

              <div class="place-one-hover">
                <div class="place-one-hover-title">
                  {{ item.text }}
                </div>
                <div class="place-one-hover-detail">
                  {{ item.detail }}
                </div>
                <div class="place-one-hover-btn">
                  了解更多 →
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="place-btn" @click="jumpToPlace()">
          了解更多 →
        </div>
      </div>

    <div class="white-bg">
      <!-- 走进艾感 -->
      <div class="word">
        <div class="word-title" :class="{titleMove: isTitleMove}">
          <div class="word-big">走进艾感</div>
          <div class="word-small">About Aisensing</div>
        </div>
      </div>
      <div class="aigan-box">
        <div class="aigan-left">
          <div class="aigan-left-title">艾感科技（广东）有限公司</div>
          <div class="aigan-left-text">{{companyDetail}}</div>
          <div class="aigan-left-btn" @click="toAbout()">了解更多>></div>
        </div>
        <div class="aigan-right">
          <img src="./../../assets/homeIcon/aiganhonor.png"/>
          <el-row>
              <el-col :span="8" class="aigan-right-text-one">发明专利</el-col>
              <el-col :span="8" class="aigan-right-text-one">授权专利</el-col>
              <el-col :span="8" class="aigan-right-text-one">商标</el-col>
          </el-row>
          <div class="aigan-right-content">
            <el-row>
              <el-col :span="8" v-for="(item, i) in honor" class="aigan-right-content-one">
                <span v-number-scroll="item.num" class="aigan-right-content-num" >
                  0
                </span>
                <span class="aigan-right-content-unit">{{ item.unit }}</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="toaigan">
        <div v-for="(item, index) in toAiganlist" :key="index" class="toaigan-one">
          <img :src="item.url" class="toaigan-icon" />
          <div class="toaigan-tit">{{ item.name }}</div>
          <div class="toaigan-detail">
            {{ item.detail }}<span class="font-blue">{{ item.detail_blu }}</span>{{ item.detailEnd }}
          </div>
        </div>
      </div>
    </div>

    <!-- 核心团队 -->
    <!-- <div class="word">
      <div class="word-title" :class="{titleMove: isTitleMove}">
        <div class="word-big">核心团队</div>
        <div class="word-small">Core Team</div>
      </div>
    </div>
    <div class="team-first-box" >
      <div class="team-first-one" v-for="(item, index) in teamFirst" :key="index">
        <div class="left-box">
          <div class="team-img-bg"></div>
          <img :src="item.url" class="team-user" />
          <div class="team-user-job-text">
            <img :src="imgUrl.teambg" class="team-text-bg" />
            <div class="team-text-con">{{ item.title }}</div>
          </div>
        </div>
        <div class="middle-box">
          <div>{{ item.name }}</div>
          <div>{{ item.job }}</div>
        </div>
        <div class="right-box">
          <div v-for="(obj, i) in item.detail" :key="i" class="text-one">
            <div class="dot"></div>{{ obj }}
          </div>
        </div>
      </div>
    </div>

    <div class="team-second-box" >
      <el-row :gutter="20">
        <el-col :span="isMobile?24:12" v-for="(item, index) in teamSecond" :key="index">
          <div class="team-second-one" >
            <div class="left-box">
              <div class="team-img-bg"></div>
              <img :src="item.url" class="team-user" />
              <div class="team-user-job-text">
                <img :src="imgUrl.teambg" class="team-text-bg" />
                <div class="team-text-con">{{ item.title }}</div>
              </div>
            </div>
            <div class="right-box">
              <div class="title-box">
                <div>{{ item.name }}</div>
                <div>{{ item.job }}</div>
              </div>
              <div v-for="(obj, i) in item.detail" :key="i" class="text-one">
                <div class="dot"></div>{{ obj }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div> -->

    <!-- 宣传片 -->
    <div class="word">
      <div class="word-title" ref="wordRef" :class="{titleMove: isTitleMove}">
        <div class="word-big">视频速览</div>
        <div class="word-small">Video Overview</div>
      </div>
    </div>
    <div class="videobox">
      <el-row :gutter="20">
        <el-col :span="isMobile?24:8" v-for="(item,index) in videolist" :key="index+100" >
          <div class="videolist"> 
            <div class="content">
              <div class="video-one">
                <div class="bigImg">
                  <Video :videoUrl="item.videoUrl" :bgUrl="item.coverImg"></Video>
                </div>
              </div>
              <div class="video-word">
                <div class="title">{{item.title}}</div>
                <div class="text">{{item.content}}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="videobox-btn" @click="toNews(2)">了解更多>></div>
    </div>

    <!-- 新闻动态 -->
    <div class="word">
      <div class="word-title" ref="wordRef" :class="{titleMove: isTitleMove}">
        <div class="word-big">公司动态</div>
        <div class="word-small">Company Updates</div>
      </div>
    </div>
    <div class="videobox">
      <el-row :gutter="20">
        <el-col :span="isMobile?24:8" v-for="(item,index) in companyUpdatelist" :key="index+100" >
          <div class="videolist"> 
            <div class="content">
              <div class="video-one">
                <img :src="require(`./../../assets/news/${item.imgUrl}`)" class="bigImg"></img>
              </div>
              <div class="video-word">
                <div class="title">
                  {{item.title}}
                  <a :href="item.url" target="_blank" v-if="item.url!==''">
                    <i class="el-icon-top-right jumpToOutlink"></i>
                  </a>
                </div>
                <div class="text">{{item.text}}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="videobox-btn" @click="toNews(0)">了解更多>></div>
    </div>

    <div class="word">
      <div class="word-title" ref="wordRef" :class="{titleMove: isTitleMove}">
        <div class="word-big">行业方案</div>
        <div class="word-small">Industry Solutions</div>
      </div>
    </div>
    <div class="videobox">
      <el-row :gutter="20">
        <el-col :span="isMobile?24:8" v-for="(item,index) in industrySolulist" :key="index+100" >
          <div class="videolist"> 
            <div class="content">
              <div class="video-one">
                <img :src="require(`./../../assets/news/${item.imgUrl}`)" class="bigImg"></img>
              </div>
              <div class="video-word">
                <div class="title">
                  {{item.title}}
                  <a :href="item.url" target="_blank" v-if="item.url!==''">
                    <i class="el-icon-top-right jumpToOutlink"></i>
                  </a>
                </div>
                <div class="text">{{item.text}}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="videobox-btn" @click="toNews(1)">了解更多>></div>
    </div>

  </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/swiper.min.css"
import imgUrl from "@/utils/imgUrl"
import arrJson from '@/utils/arrJson'
import { createNumberScrollDirective } from '@/utils/VueNumberScroll.js';
import Video from '@/components/video.vue'

export default {
  name: 'Home',

  // 在组件内注册局部指令
  directives: {
    'number-scroll': createNumberScrollDirective({
      duration: 1600,
      easing: 'easeOut',
      separator: ',',
      once: false
    })
  },
  components: {
    Video,
  },
  data() {
    return {
      isMobile: window.innerWidth < 780,
      imgUrl:imgUrl,
      intellectualList: arrJson.intellectualList,
      honorList: arrJson.honorList,
      companyDetail: arrJson.companyDetail,
      videolist: arrJson.videolist.slice(0,3),
      productlist: [
        {
          name: "气体传感器",
          url: imgUrl.sensor,
          tip: "chip",
          id: 0
        }, {
          name: "气体传感器模组",
          url: imgUrl.mozu,
          tip: "mozu",
          id: 1
        }, {
          name: "嗅觉芯片",
          url: imgUrl.elenose,
          tip: "elenose",
          id: 2
        }, {
          name: "监测系统",
          url: imgUrl.system,
          tip: "system",
          id: 3
        }
      ],
      solutionlist: [
        {
          text: "智能家居",
          icon: imgUrl.solutionIcon01,
          bg: imgUrl.solutionBg01,
          id: 0
        }, {
          text: "环境监测",
          icon: imgUrl.solutionIcon02,
          bg: imgUrl.solutionBg02,
          id: 1
        }, {
          text: "康养护理",
          icon: imgUrl.solutionIcon04,
          bg: imgUrl.solutionBg04,
          id: 2
        }, {
          text: "工业安全",
          icon: imgUrl.solutionIcon05,
          bg: imgUrl.solutionBg05,
          id: 3
        }, {
          text: "标准化气体",
          icon: imgUrl.solutionIcon03,
          bg: imgUrl.solutionBg03,
          id: 4
        }
      ],
      toAiganlist: [
        {
          name: "高精度感知",
          detail: "自主研发，检测精度",
          detail_blu: "ppb",
          detailEnd: "级",
          url: imgUrl.aiganIcon01
        },  {
          name: "快速响应",
          detail: "",
          detail_blu: "10秒",
          detailEnd: "内精准识别目标气体",
          url: imgUrl.aiganIcon02
        },  {
          name: "全场景适配技术",
          detail: "提供从芯片到系统",
          detail_blu: "全栈",
          detailEnd: "方案",
          url: imgUrl.aiganIcon03
        },  {
          name: "定制化服务",
          detail: "",
          detail_blu: "千万",
          detailEnd: "用户验证",
          url: imgUrl.aiganIcon04
        }
      ],
      honor: [
        {
          num: 81,
          unit: "件"
        }, {
          num: 39,
          unit: "件"
        }, {
          num: 28,
          unit: "项"
        }
      ],
      companyUpdatelist: arrJson.lastNews.slice(0,3),
      industrySolulist: arrJson.oldNews.slice(0,3),
      placelist: arrJson.placelist,
      teamFirst: arrJson.teamlist,
      teamSecond: [],
      isTitleMove: false,
      isHonorMove: false,
      testShow: false,
      height1: "",
      height2: "",
      swiper1: null,
      swiper2: null,
      // 动态配置
      config: {
        number: 8888,
        duration: 2500,
        easing: 'easeOut',
        separator: ',',
        prefix: '$',
        suffix: ''
      },
    }
  },
  mounted(){
    const thisScreenWid = window.innerWidth
    window.addEventListener("scroll", this.moveWord, true)
    window.addEventListener("resize", this.initFunc)
    this.height1 = this.isMobile ? (thisScreenWid-40)/2/213*300+"px" : "485px"
    this.height2 = this.isMobile ? (thisScreenWid-40)/2/350*250+"px" : "246px"

    this.setSwiper()
    this.setCard()
    this.initResizeObserver()
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
    window.removeEventListener("scroll", this.moveWord)
  },
  methods: {
    setSwiper(){
      const t = this
      this.swiper1 = new Swiper('.swiper', {
        pagination: false,
        loop: true, // 是否循环，内容会两倍
        autoplay: {
          delay: 0,  // 切换间隔时间（毫秒）
          disableOnInteraction: false,  // 用户操作后不停止自动播放
          pauseOnMouseEnter: true,      // 关键参数：鼠标移入暂停
        },
        speed: 3000,
        clickable: true,
        slidesPerView: t.isMobile ? 2 : 4,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          click: function(swiper, event) {
            t.seeProductDetail(Number(swiper.clickedSlide.dataset.id))
          }
        }
      })
      this.swiper1.autoplay.start();
    },
    setCard(){
      // 获取所有卡片和容器
      const cards = document.querySelectorAll('.card');
      const container = document.querySelector('.cards-container');
      
      // 记录最后一次激活的卡片索引
      let lastActiveIndex = 2;

      // 默认激活第三个卡片（索引2）
      if (cards.length >= 3) {
        cards[2].classList.add('active');
      }
      
      // 鼠标移入事件
      cards.forEach((card, index) => {
        card.addEventListener('mouseenter', function() {
          lastActiveIndex = index;

          // 移除所有卡片的active类
          cards.forEach(c => {
            c.classList.remove('active');
          });
          
          // 为当前卡片添加active类
          this.classList.add('active');
        });
      });
    },
    seeProductDetail(item){
      window.sessionStorage.setItem('productClassId', item+1);
      this.$router.push({ path: '/product' })
    },
    seePlanDetail(item){
      if(item.id>=0){
        window.sessionStorage.setItem('productClassId', item.id+1);
      }
      this.$router.push({ path: '/plan' })
    },
    jumpToPlace(index){
      if (index>=0){
        window.sessionStorage.setItem('placeId', index);
      }

      this.$router.push({ path: '/place' })
    },
    toNews(i){
      window.sessionStorage.setItem('overviewRefId', i);
      this.$router.push({ path: '/news' })
    },
    moveWord() {
      const currentScroll = window.scrollY;
      const thisScreenHei = window.screen.height
      // if(currentScroll >= this.$refs.overviewRef.offsetTop - thisScreenHei + 350 ){
      //   this.testShow = true
      // }
      // if(currentScroll >= this.$refs.wordRef.offsetTop - thisScreenHei + 150 ){
      //   this.isTitleMove = true
      // }
      // if(currentScroll >= this.$refs.honorRef.offsetTop - thisScreenHei + 150 ){
      //   this.isHonorMove = true
      // }
    },
    initFunc() {
      if(this.isMobile !== (window.innerWidth < 780)){
        this.isMobile = window.innerWidth < 780
        this.swiper1.params.slidesPerView = this.isMobile ? 1 : 4;
        // this.swiper2.params.slidesPerView = this.isMobile ? 1 : 3;
      }
    },
    initResizeObserver() {
      // 添加 try-catch 忽略特定错误
      const callback = (entries) => {
        try {
          // 你的处理逻辑
          this.handleResize(entries)
        } catch (error) {
          if (error.message.includes('ResizeObserver loop limit exceeded')) {
            // 忽略这个错误
            return
          }
          throw error
        }
      }
      
      this.resizeObserver = new ResizeObserver(callback)
      this.resizeObserver.observe(this.$el)
    },
    handleResize(entries) {
      // 实际的尺寸变化处理逻辑
      entries.forEach(entry => {
        // console.log('尺寸变化:', entry.contentRect)
      })
    },
    toAbout(){
      this.$router.push({ path: '/about' })
    },
    updateDemo() {
      // 重置所有动画
      this.$numberScroll.resetAll()
      
      // 滚动到演示区域
      setTimeout(() => {
        const section = document.querySelector('.aaaa');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    },
  },
  // beforeDestroy() {
  //   window.removeEventListener("scroll", this.moveWord, true)
  // },
}
</script>


<style scoped lang="less">
  .home-box{
    background-color: #F5F6FA;
  }
  .swiper{
    position: relative;
  }
  .honor-part{
    background: #edf1f4;
  }
  /deep/.swiper-pagination-bullets{
    .swiper-pagination-bullet{
      width: 12px;
      height: 12px;
      background: #0b55dc;
    }
  }

  .white-bg{
    background-color: #fff;
  }
  /* 响应式设计 */
  @media (max-width: 900px) {
    .cards-container {
      width: 95%;
      height: 350px;
    }
  }

  @media (max-width: 780px) {
    .cards-container {
      flex-direction: column;
      height: auto;
      width: 95%;
      gap: 15px;
    }
    
    .card {
      // height: 80px;
      // margin: 0;
    }
    
    .card.active{
      // flex: 1;
      // height: 200px;
    }
    
    .cards-container:hover .card:not(.active):not(:hover) {
      // flex: 1;
      // height: 80px;
    }
    
    /* 移动端触摸设备可能没有鼠标悬停，可以添加触摸支持 */
    .card.touch-active {
      // flex: 1;
      // height: 200px;
    }
  }
  // PC
  .main{
    .word-title{
      text-align: left;
      // transform: translateY(-40%);
      // margin-top: 40px;
      .word-big{
        line-height: 44px;
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        color: #313E47;
        padding-top: 60px;
      }
      .word-small{
        color: #313E47;
        font-size: 16px;
        line-height: 26px;
        font-weight: normal;
        text-align: center;
        // letter-spacing: 3px;
      }
    }

    .overview{
      padding: 60px 0 0;
      .overview-title{
        font-size: 30px;
        line-height: 34px;
        color: #313E47;
        font-weight: bold;
        text-align: center;
      }
      .overview-subtitle{
        font-size: 16px;
        line-height: 26px;
        color: #313E47;
        text-align: center;
      }
      .overview-content{
        margin: 30px auto 0;
        padding: 20px 0;
        max-width: 1400px;
        background-color: #fff;
        border-radius: 30px;
        overflow: hidden;
        .projectlist_prev,.projectlist_next{
          background-color: #00D0FF;
          color: #fff;
        }
        .projectlist_prev:after,.projectlist_next:after{
          font-size: 12px;
        }
        .overview-content-one{
          border-right: 1px solid #eee;
        }
      }
    }
    .honor-part{
      background: url('../../assets/banner/bg.jpg');
      background-size: 100% 100%;
    }
    .titleMove{
      transform: translateY(0);
      transition: all 1s;
      -ms-transition: all 1s;
    }
    /deep/ .el-card__body, .el-main{
      padding: 0;
    }
    .word-btn{
      background: rgb(39, 44, 55);
      border: none;
      color: #ffffffc9;
      margin: 24px 0;
    }

    .swipperItem{
      position: relative;
      text-align: left;
      padding: 4% 6%;
      cursor: default;
      .img-up-word{
        .img-up-word-content{
          margin: 20px 0px 0;
          font-size: 16px;
        }
        .img-up-word-dec{
          font-size: 14px;
          margin: 0 10px;
        }
      }
    }
    .swiper-pagination-intellectual{
      margin: 20px 0;
      text-align: center;
    }
    .swiper-pagination-honor{
      margin: 20px 0;
      text-align: center;
    }

    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 200px;
      margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: #d3dce6;
    }
    .bannerList{
      max-width: 1400px;
      margin: 0 auto;
      overflow: hidden;
    }

    .overview-content-one{
      .imgbox{
        height: 200px;
        text-align: center;
        img{
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .content{
        text-align: center;
        margin-top: 20px;
        .word{
          font-size: 20px;
        }
        .btn{
          background-color: #eee;
          padding: 6px 20px;
          display: inline-block;
          margin: 30px auto 20px;
          border-radius: 20px;
        }
      }

    }
    .swipperItem .img-up-word{
      .img-up-word-content{
        text-align: center;
        font-size: 16px;
      }
      .img-up-word-dec{
        text-align: center;
        font-size: 20px;
      }
    }
    // 卡片开始
    .cards-container {
      display: flex;
      max-width: 1400px;
      height: 500px;
      margin: 20px auto 0;
      position: relative;
      .card-big-pic {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .card-icon {
        text-align: center;
        top: 200px;
        left: 50%;
        margin-left: -35px;
        position: absolute;
        z-index: 1;
      }
      .card-icon-img {
        width: 70px;
        height: 70px;
      }
      .card-icon-text{
        color: #fff;
        font-size: 16px;
        line-height: 40px;
      }
      .card {
        position: relative;
        flex: 1;
        height: 100%;
        border-radius: 15px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        margin: 0 10px;
        justify-content: flex-end;
      }

      /* 默认激活第三个卡片 */
      // .card:nth-child(3) {
      //   flex: 2;
      //   box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
      // }

      /* 激活状态的卡片 */
      .card.active {
        flex: 2 !important;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3) !important;
        .card-icon-text{
          font-size: 20px;
        }

      }

      /* 非激活状态的卡片 */
      .cards-container:not(:hover) .card:not(.active),
      .cards-container:hover .card:not(.active):not(:hover) {
        flex: 1;
      }

      /* 悬停时其他非激活卡片 */
      .cards-container:hover .card:not(.active):not(:hover) {
        flex: 0.7;
      }

      .card-content {
        opacity: 0.9;
        transition: all 0.4s ease 0.1s;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #4B5761;
        backdrop-filter: blur(10px) saturate(200%);
      }

      .card.active .card-content {
        opacity: 0;
        transform: translateY(0);
      }

    }
    .aigan-box{
      max-width: 1400px;
      margin: 20px auto 0;
      .aigan-left{
        display: inline-block;
        vertical-align: middle;
        width: 50%;
        .aigan-left-title{
          font-size: 24px;
          line-height: 70px;
          font-weight: bold;
        }
        .aigan-left-text{
          line-height: 30px;
          color: #989898;
          width: 84%;
          font-size: 17px;
        }
        .aigan-left-btn{
          padding: 10px 30px;
          cursor: pointer;
          display: inline-block;
          border: 1px solid #909090;
          border-radius: 25px;
          margin: 22px 0;
        }
      }
      .aigan-right{
        display: inline-block;
        width: 50%;
        vertical-align: middle;
        margin-top: -6px;
        position: relative;
        img{
          width: 100%;
          opacity: 0.85;
        }
        .aigan-right-text-one{
          line-height: 40px;
          font-size: 22px;
          color: #394c5b;
          text-align: center;
        }
        .aigan-right-content{
          position: absolute;
          top: 30px;
          width: 100%;
          color: #394c5b;
          .aigan-right-content-one{
            text-align: center;
          }
          .aigan-right-content-num{
            font-size: 34px;
            font-weight: bold;
          }
          .aigan-right-content-unit{
            font-size: 34px;
            font-weight: bold;
          }
        }
      }
    }
    .toaigan{
      margin: 20px auto;
      max-width: 1400px;
      .toaigan-one{
        width: 25%;
        display: inline-block;
        text-align: center;
        .toaigan-icon{
          width: 60px;
          height: 60px;
        }
        .toaigan-tit{
          font-size: 20px;
          line-height: 56px;
          font-weight: bold;
        }
        .toaigan-detail{
          font-size: 16px;
          line-height: 40px;
          margin-bottom: 40px;
          .font-blue{
            color: #00D0FF;
          }

        }
      }
    }
    .place-box{
      max-width: 1400px;
      margin: 20px auto;
      .place-one{
        margin: 20px;
        box-sizing: border-box;
        background-color: #F2FCFF;
        text-align: center;
        padding: 70px 80px 50px;
        position: relative;
        .place-one-img{
          width: 100%;
          // height: 150px;
        }
        .place-one-text{
          line-height: 60px;
          font-size: 20px
        }
        .place-one-hover{
          opacity: 0;
          background-color: #1fc4e9;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          padding: 20px;
          box-sizing: border-box;
          color: #fff;
          border-radius: 10px;
          font-weight: normal;
          transition: opacity 0.3s ease;
          .place-one-hover-title{
            line-height: 70px;
            font-size: 21px;
          }
          .place-one-hover-detail{
            font-size: 14px;
            line-height: 26px;
            padding-bottom: 20px;
            border-bottom: 1px solid #ffffff40;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;  /* 限制显示4行 */
            overflow: hidden;
            text-overflow: ellipsis;
            max-height: 88px;
          }
          .place-one-hover-btn{
            line-height: 80px;
            cursor: pointer;
          }
        }
      }
      .place-one:hover{
        .place-one-hover{
          opacity: 1;
          animation: 1s;
        }
      }
      .place-btn{
        display: none;
      }
    }
    .team-first-box{
      max-width: 1400px;
      margin: 0 auto;
      .team-first-one{
        margin: 120px 0 24px;
        background: #fff;
        border-radius: 20px;
      }
      .left-box{
        display: inline-block;
        width: 18%;
        position: relative;
        text-align: center;
        top: -55px;
        margin-left: 1%;
        .team-img-bg{
          width: 200px;
          height: 200px;
          border-radius: 50%;
          // background-image: linear-gradient(to bottom, #A5E0FF, #EBF8FF);
          margin: 0 auto;
        }
        .team-user{
          position: absolute;
          top: 15px;
          left: 50%;
          width: 170px;
          height: 170px;
          margin-left: -85px;
        }
        .team-user-job-text{
          position: relative;
          margin: -44px auto 0px; 
          .team-text-bg{
            width: 200px;
            position: absolute;
            left: 34px;
            bottom: -26px;
          }
          .team-text-con{
            top: 6px;
            left: 4px;
            color: #fff;
            // z-index: 1000;
            position: relative;
          }
        }
      }
      .middle-box{
        display: inline-block;
        width: 30%;
        vertical-align: top;
        font-size: 20px;
        line-height: 31px;
        font-weight: bold;
        margin-top: 30px;
        margin-left: 2%;
      }
      .right-box{
        display: inline-block;
        vertical-align: top;
        width: 46%;
        line-height: 26px;
        font-size: 14px;
        color: #757575;
        margin: 20px 0;
        .dot{
          width: 4px;
          height: 4px;
          display: inline-block;
          border-radius: 50%;
          background-color: #9f9f9f;
          margin-right: 10px;
        }
      }
    }
    .team-second-box{
      border-radius: 20px;
      width: 1400px;
      margin: 0 auto;
      .team-second-one{
        background-color: #fff;
        margin: 30px 0 0 0;
        // display: inline-block;
        // width: 48%;
        border-radius: 20px;
        height: 200px;
      }
      .left-box{
        display: inline-block;
        width: 30%;
        position: relative;
        text-align: center;
        top: -84px;
        margin-left: 1%;
        .team-img-bg{
          width: 140px;
          height: 150px;
          border-radius: 50%;
          // background-image: linear-gradient(to bottom, #A5E0FF, #EBF8FF);
          margin: 0 auto;
        }
        .team-user{
          position: absolute;
          top: -21px;
          left: 50%;
          width: 210px;
          height: 210px;
          margin-left: -106px;
        }
        .team-user-job-text{
          position: relative;
          margin: -44px auto 0px; 
          .team-text-bg{
            width: 150px;
            position: absolute;
            left: 38px;
            bottom: -26px;
          }
          .team-text-con{
            top: 11px;
            left: 4px;
            color: #fff;
            // z-index: 1000;
            position: relative;
            font-size: 14px;
          }
        }
      }
      .right-box{
        display: inline-block;
        width: 60%;
        line-height: 26px;
        font-size: 14px;
        color: #757575;
        margin: 20px 0;
        .title-box{
          display: inline-block;
          vertical-align: top;
          font-size: 20px;
          line-height: 31px;
          font-weight: bold;
          margin-left: 2%;
          color: #000;
        }
        .dot{
          width: 4px;
          height: 4px;
          display: inline-block;
          border-radius: 50%;
          background-color: #9f9f9f;
          margin-right: 10px;
        }
      }
    }
    .videobox{
      max-width: 1400px;
      margin: 0 auto;
      padding-bottom: 60px;
      text-align: center;
      .videobox-btn{
        padding: 10px 60px;
        cursor: pointer;
        display: inline-block;
        border: 1px solid #909090;
        border-radius: 25px;
        margin: 0 auto 10px;
      }
    }
    .videolist{
      text-align: left;
      margin-bottom: 60px;

      .video-one{
        padding: 40px 40px 0;
      }
      .bigImg{
        width: 100%;
        display: block;
        max-height: 210px;
        border-radius: 10px;
      }
      .video-word{
        text-align: center;
        vertical-align: top;
        padding: 0 0 0 2%;
        .title{
          color: #000000;
          font-size: 18px;
          line-height: 60px;
          display: inline-block;
          font-weight: bold;
        }
        .jumpToOutlink{
          margin: 0 10px;
          color: #989898;
          font-size: 20px;
        }
        .text{
          color: #989898;
          font-size: 15px;
          line-height: 26px;
          white-space: nowrap;      /* 不换行 */
          overflow: hidden;         /* 隐藏溢出内容 */
          text-overflow: ellipsis;  /* 显示省略号 */
          width: 100%;  
        }
      }
    }
  }


//移动端
  .main-m{
    .bannerList{
      width: 100%;
      overflow: hidden;
    }
    .img-up-word{
      .img-up-word-content{
        margin: 5rem 0.2rem 0;
        font-size: 0.4rem;
      }
      .img-up-word-dec{
        font-size: 0.24rem;
        margin: 0 0.2rem;
      }
    }
    .word-title{
      text-align: center;
      padding: 0.8rem 0 0;
      .word-big{
        line-height: 1.2rem;
        font-size: 0.6rem;
        font-weight: 500;
      }
      .word-small{
        color: #9b9b9b;
        font-size: 0.4rem;
      }
    }
    .overview{
      padding: 1rem 0 0;
      .overview-content{
        overflow: hidden;
        .projectlist_prev,.projectlist_next{
          background-color: #00D0FF;
          color: #fff;
        }
        .projectlist_prev:after,.projectlist_next:after{
          font-size: 0.3rem;
        }
        .overview-content-one{
          border-right: 0.01rem solid #eee;
        }
      }
      .overview-title{
        font-size: 0.6rem;
        line-height: 1.2rem;
        text-align: center;
      }
      .overview-subtitle{
        line-height: 0.6rem;
        color: #9b9b9b;
        font-size: 0.4rem;
        text-align: center;
      }
    }
    .honor-part{
      background: url('../../assets/banner/bg.jpg');
      background-size: 100% 100%;
    }
    .swiper-pagination-intellectual{
      text-align: center;
    }
    .swiper-pagination-honor{
      text-align: center;
    }
    /deep/.swiper-pagination-bullet{
      width: 0.2rem;
      height: 0.2rem;
    }
    .swipperItem{
      position: relative;
      text-align: left;
      padding: 0 6% 0;
      cursor: default;
      .imgbox{
        text-align: center;
        background-color: #fff;
        padding: 0.4rem;
        margin: 0.4rem 0.4rem ;
        box-sizing: border-box;
        border-radius: 0.36rem;
        img{
          max-width: 80%;
          max-height: 2.4rem;
        }
      }
      .content{
        text-align: center;
        overflow: hidden;
        .word{
          font-size: 0.4rem;
        }
        .btn{
          font-size: 0.4rem;
          background-color: #eee;
          padding: 0.3rem 0.8rem;
          display: inline-block;
          margin: 0.2rem auto 0;
          border-radius: 0.3rem;
        }
      }
      .img-up-word{
        .img-up-word-content{
          margin: 0.4rem 0px 0;
          font-size: 0.32rem;
        }
        .img-up-word-dec{
          font-size: 0.28rem;
          margin: 0 0.2rem;
        }
      }
    }
    .cards-container{
      margin: 0.4rem auto 0.2rem;
      .card{
        // background-color: #e4e4e4;
        background-image: linear-gradient(to bottom, #A5E0FF, #EBF8FF);
        border-radius: 0.5rem;
        text-align: center;
        padding: 0.2rem;
        box-sizing: border-box;
        margin: 0.1rem 0.04rem;
        display: inline-block;
        width: 32.4%;
        text-align: center;
        .card-icon-img{
          width: 0.8rem;
          margin: 0.6rem auto 0.2rem;
          display: block;
          font-size: 0.8rem;
          color: #fff;
        }
        .card-icon-text{
          display: block;
          font-size: 0.4rem;
          margin-bottom: 0.5rem;
        }
      }
    }
    .place-box{
      text-align: center;
      overflow: hidden;
      .place-one{
        margin: 0.4rem;
        .place-one-img{
          width: 2rem;
          height: 2rem;
        }
        .leftbox{
          display: inline-block;
          width: 25%;
          vertical-align: middle;
          text-align: left;
        }
        .place-one-text{
          text-align: center;
          font-size: 0.5rem;
          display: none;
        }
        .place-one-hover{
          display: inline-block;
          vertical-align: middle;
          width: 75%;
          .place-one-hover-title{
            font-size: 0.4rem;
            font-weight: bold;
            line-height: 0.8rem;
            text-align: left;
          }
          .place-one-hover-detail{
            font-size: 0.34rem;
            line-height: 0.5rem;
            text-align: justify;
            // text-indent: 32px;
            color: #989898;
          }
          .place-one-hover-btn{
            display: none;
          }
        }
      }
      .place-btn{
        font-size: 0.42rem;
        border: 0.02rem solid #bbbbbb;
        border-radius: 1rem;
        padding: 0.2rem 0.8rem;
        display: inline-block;
        margin: 0.4rem 0 1rem;
      }
    }
    .aigan-box{
      width: 90%;
      margin: 0.4rem auto;
      .aigan-left{
        .aigan-left-title{
          font-size: 0.4rem;
          line-height: 0.8rem;
        }
        .aigan-left-text{
          font-size: 0.34rem;
          line-height: 0.6rem;
        }
        .aigan-left-btn{
          font-size: 0.36rem;
          margin: 0.2rem 0 0.4rem;
          text-align: right;
        }
      }

      .aigan-right{
        vertical-align: middle;
        margin-top: -0.12rem;
        position: relative;
        img{
          width: 100%;
          opacity: 0.85;
        }
        .aigan-right-text-one{
          line-height: 0.8rem;
          font-size: 0.44rem;
          color: #394c5b;
          text-align: center;
        }
        .aigan-right-content{
          position: absolute;
          top: 0;
          width: 100%;
          color: #394c5b;
          .aigan-right-content-one{
            text-align: center;
          }
          .aigan-right-content-num{
            font-size: 0.68rem;
            font-weight: bold;
          }
          .aigan-right-content-unit{
            font-size: 0.68rem;
            font-weight: bold;
          }
        }
      }
    }
    .toaigan{
      padding-bottom: 1rem;
      .toaigan-one{
        width: 50%;
        display: inline-block;
        text-align: center;
        margin: 0.3rem 0;
        .toaigan-icon{
          width: 0.7rem;
        }
        .toaigan-tit{
          font-size: 0.34rem;
          line-height: 0.58rem;
        }
        .toaigan-detail{
          font-size: 0.3rem;
          color: #989898;
        }
      }
    }
    .team-first-box{
      border-radius: 0.4rem;
      width: 90%;
      margin: 1rem auto 0rem;
      .left-box{
        // display: inline-block;
        position: relative;
        text-align: center;
        top: -0.4rem;
        // margin-left: 1%;
        .team-img-bg{
          width: 4rem;
          height: 4rem;
          border-radius: 50%;
          // background-image: linear-gradient(to bottom, #A5E0FF, #EBF8FF);
          margin: 0 auto;
        }
        .team-user{
          position: absolute;
          top: 0.5rem;
          left: 50%;
          width: 3.4rem;
          height: 3.4rem;
          margin-left: -1.6rem;
        }
        .team-user-job-text{
          position: relative;
          margin: -0.8rem auto 0; 
          .team-text-bg{
            width: 5rem;
            position: absolute;
            left: 50%;
            margin-left: -2.5rem;
            bottom: -1rem;
          }
          .team-text-con{
            top: 0.5rem;
            left: 0;
            color: #fff;
            // z-index: 1000;
            position: relative;
            font-size: 0.32rem;
          }
        }
      }
      .middle-box{
        font-size: 0.4rem;
        line-height: 0.6rem;
        color: #000;
        margin-top: 0.6rem;
        font-weight: bold;
      }
      .right-box{
        display: inline-block;
        width: 100%;
        line-height: 0.58rem;
        font-size: 0.34rem;
        color: #757575;
        margin: 0.4rem 0 0.6rem;
        .title-box{
          display: inline-block;
          vertical-align: top;
          font-size: 0.4rem;
          line-height: 0.6rem;
          font-weight: bold;
          margin-left: 2%;
          color: #000;
        }
        .dot{
          width: 0.08rem;
          height: 0.08rem;
          display: inline-block;
          border-radius: 50%;
          background-color: #9f9f9f;
          margin-right: 0.2rem;
        }
      }
    }
    .videobox{
      max-width: 90%;
      margin: 0 auto;
      text-align: center;
      .videobox-btn{
        padding: 0.2rem 1.2rem;
        cursor: pointer;
        display: inline-block;
        border: 0.02rem solid #909090;
        border-radius: 0.5rem;
        margin: 0 auto 0.8rem;
        font-size: 0.26rem;
      }
    }
    .videolist{
      .bigImg{
          width: 100%;
          display: block;
          max-height: 6rem;
          border-radius: 0.2rem;
          margin-top: 0.4rem;
        }
      .video-word{
        text-align: center;
        vertical-align: top;
        .title{
          color: #000000;
          font-size: 0.38rem;
          display: inline-block;
          font-weight: bold;
        }
        .text{
          color: #989898;
          font-size: 0.34rem;
          line-height: 0.52rem;
          white-space: nowrap;      /* 不换行 */
          overflow: hidden;         /* 隐藏溢出内容 */
          text-overflow: ellipsis;  /* 显示省略号 */
          width: 100%;  
          margin-bottom: 0.4rem;
        }
      }
    }
    .swiper-pagination-intellectual{
      margin: 20px 0;
      text-align: center;
    }
    .swiper-pagination-honor{
      margin: 20px 0;
      text-align: center;
    }
  }
</style>
